import React, { useState } from "react";
import { FaRegSave } from "react-icons/fa";
import "./ScanningAssigning.css";

// Sample data - replace with API data or pass departments / users as props
const DEFAULT_DEPARTMENTS = ["All Departments", "CROWN AND BRIDGE", "ORTHODONTIC", "IMPLANTS", "All Departments", "No Department"];
const DEFAULT_USERS = ["Admin SM", "hafiz ayub", "Hira KH", "User 4", "User 5"];
const OPTIONS = [
  { key: "scan", label: "Scan" },
  { key: "assign", label: "Be Assigned" },
];

// onSave({ "deptIndex-userIndex-scan": true/false, ... }) - connect your API here
const ScanningAssigning = ({ departments = DEFAULT_DEPARTMENTS, users = DEFAULT_USERS, onSave }) => {
  const [off, setOff] = useState({}); // everything is checked unless listed here
  const isOn = (k) => !off[k];
  const toggle = (k) => setOff((o) => ({ ...o, [k]: isOn(k) }));

  const save = () => {
    if (!onSave) return;
    const out = {};
    departments.forEach((_, di) =>
      users.forEach((__, ui) => OPTIONS.forEach((o) => { const k = `${di}-${ui}-${o.key}`; out[k] = isOn(k); }))
    );
    onSave(out);
  };

  return (
    <div className="sa-page">
      <h3 className="sa-title">Scanning and Assigning</h3>

      <div className="sa-scroll">
        <table className="sa-table">
          <thead>
            <tr>
              <th rowSpan={2} className="sa-dept">Departments</th>
              <th colSpan={users.length * 2}>Users</th>
            </tr>
            <tr>
              {users.map((u) => <th key={u} colSpan={2}>{u}</th>)}
            </tr>
          </thead>
          <tbody>
            {departments.map((d, di) => (
              <tr key={di}>
                <th className="sa-dept">{d}</th>
                {users.flatMap((u, ui) =>
                  OPTIONS.map((o) => {
                    const k = `${di}-${ui}-${o.key}`;
                    return (
                      <td key={k}>
                        <label className="sa-check">
                          <input type="checkbox" checked={isOn(k)} onChange={() => toggle(k)} />
                          <span>{o.label}</span>
                        </label>
                      </td>
                    );
                  })
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button type="button" className="sa-save" onClick={save}><FaRegSave /> Save</button>
    </div>
  );
};

export default ScanningAssigning;